import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m14.484 13.537-2.473-2.453a6 6 0 1 0-.927.927l2.453 2.453a.667.667 0 0 0 .947 0 .666.666 0 0 0 0-.927m-7.14-1.526a4.667 4.667 0 1 1 0-9.333 4.667 4.667 0 0 1 0 9.333m2.667-5.334H4.677a.667.667 0 1 0 0 1.334h5.334a.667.667 0 1 0 0-1.334"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })